import { z } from "zod";

import { Roles } from "src/core/constants/roles";
import { User } from "src/core/gql/graphql";

export const createClientCommonSchema = z.object({
  expertComptable: z.string(),
  isFollowing: z.boolean().optional(),
  folowers: z.array(z.string()).optional(),
});

export type CreateClientCommonFieldsValues = z.infer<typeof createClientCommonSchema>;

export const defaultCreateClientCommonValues = (
  user: User,
  hasRole: (role: Roles) => boolean
): CreateClientCommonFieldsValues => {
  return {
    expertComptable: hasRole(Roles.EXPERT_COMPTABLE) || hasRole(Roles.ASSOCIE) ? user.id : "",
    isFollowing: hasRole(Roles.COLLABORATEUR) ? true : false,
    folowers: [],
  };
};
